<template>
  <div class="exam-profiles-new width-responsiveness--centralized">
    <modal
      ref="transferModal"
      template="loading"
      ref-name="transferModal"
      title="Aguarde"
    >
      <p>Salvando Perfil de Exames...</p>
    </modal>

    <modal
      ref="alreadyExistsModal"
      template="neutral"
      title="Não foi possível completar a ação"
      ref-name="alreadyExistsModal"
      first-button-text="CONCLUIR"
      :icon-enabled="false"
      :close-button-enabled="false"
      class="modal-alredy-exists"
      @first-cta="closeAlreadyExistsModal()"
    >
      <div class="modal-container">
        <div class="content">
          <div class="img-wrapper">
            <img
              src="/static/images/icon-alert-modal.svg"
              alt="icone-alerta"
            >
          </div>
          <div class="message">
            <p>{{ errorMessage }}</p>
          </div>
        </div>
        <button
          class="highlight"
          @click="closeAlreadyExistsModal"
        >
          OK
        </button>
      </div>
    </modal>

    <div class="exam-profiles-new__container">
      <subheader
        :title="title"
        :centralized="true"
        :back-button-visible="true"
      />

      <div
        v-if="loading"
        class="exam-profiles-new__loading"
      >
        <Spinner />
      </div>

      <div
        v-else
        class="exam-profiles-new__container"
      >
        <div class="exam-profiles-new__form">
          <p v-if="!isEdit">
            Nomeie e adicione exames para criar um novo perfil de exames:
          </p>

          <!-- DADOS DO PERFIL -->
          <card-form :collapsed="true">
            <div
              slot="expanded"
              class="form-container"
            >
              <md-layout
                :md-gutter="24"
                md-flex="100"
              >
                <md-layout
                  md-flex="100"
                  md-flex-medium="100"
                >
                  <h2
                    id="doctorFormTitle"
                    class="exam-profiles-new__title title-main"
                  >
                    Dados do Perfil
                  </h2>
                </md-layout>
                <md-layout
                  md-flex="50"
                  md-flex-medium="50"
                >
                  <md-input-container
                    id="profileName"
                    :class="{ 'md-input-invalid': errors.has('name') }"
                  >
                    <label>Nome do Perfil *</label>
                    <md-input
                      id="txtProfileName"
                      v-model="name"
                      v-validate="'required'"
                      data-vv-validate-on="none"
                      name="name"
                      maxlength="60"
                      type="text"
                      title
                      placeholder="Nome do Perfil *"
                    />
                    <span class="md-error">Obrigatório</span>
                  </md-input-container>
                </md-layout>
                <md-layout
                  md-flex="50"
                  md-flex-medium="50"
                >
                  <md-input-container
                    id="authorName"
                    :class="{ 'md-input-invalid': errors.has('name') }"
                  >
                    <label>Responsável *</label>
                    <md-input
                      id="txtAuthorName"
                      v-model="author"
                      v-validate="'required'"
                      data-vv-validate-on="none"
                      name="author"
                      maxlength="60"
                      type="text"
                      title
                      placeholder="Responsável *"
                    />
                    <span class="md-error">Obrigatório</span>
                  </md-input-container>
                </md-layout>
              </md-layout>
            </div>
          </card-form>

          <hr class="exam-profiles-new__spacer">

          <!-- LABORATÓRIOS FILIAIS -->
          <card-form
            v-if="ableToSeeIt"
            :collapsed="true"
          >
            <div
              slot="expanded"
              class="form-container"
            >
              <md-layout
                :md-gutter="24"
                md-flex="100"
              >
                <md-layout
                  md-flex="100"
                  md-flex-medium="100"
                >
                  <h2
                    id="doctorFormTitle"
                    class="exam-profiles-new__title title-main"
                  >
                    LABORATÓRIOS FILIAIS
                    <span
                      class="exam-profiles-new__clean-btn"
                      @click="cleanItemsChecked"
                    >
                      Limpar seleção
                    </span>
                  </h2>
                </md-layout>
                <md-layout
                  md-flex="100"
                  md-flex-medium="100"
                >
                  <p>
                    Selecione as filiais que terão acesso à esse perfil de
                    exame:
                  </p>
                </md-layout>
                <md-layout
                  md-flex="100"
                  md-flex-medium="100"
                >
                  <div class="exam-profiles-new__branches">
                    <div
                      v-for="(item, index) in branches"
                      :key="index"
                      class="exam-profiles-new__item"
                    >
                      <div class="styled-checkbox">
                        <input
                          :id="
                            'chbxID' +
                              item.id_laboratory +
                              '-' +
                              item.id_laboratory
                          "
                          v-model="listBranches"
                          type="checkbox"
                          :value="{
                            id_laboratory: item.id_laboratory,
                            name_laboratory: item.name,
                          }"
                        >
                        <label
                          :for="
                            'chbxID' +
                              item.id_laboratory +
                              '-' +
                              item.id_laboratory
                          "
                        />
                      </div>
                      <label
                        :for="
                          'chbxID' +
                            item.id_laboratory +
                            '-' +
                            item.id_laboratory
                        "
                        :title="item.name"
                        class="exam-profiles-new__item__label"
                      >
                        {{ item.name }}
                      </label>
                    </div>
                  </div>
                </md-layout>
              </md-layout>
            </div>
          </card-form>
        </div>

        <div class="exam-profiles-new__search-exams">
          <p class="exam-profiles-new__text">
            Exames
          </p>

          <exams-new
            ref="examsNew"
            :is-exam-profiles="true"
          />
        </div>

        <div class="exam-profiles-new__fixed-footer">
          <div class="exam-profiles-new__footer">
            <button
              class="btn-bordered"
              @click="$router.push('/exam-profiles')"
            >
              Cancelar
            </button>
            <button
              id="newProfileBtn"
              class="btn-primary"
              :disabled="isDisabled"
              @click="handleCreate()"
            >
              <img
                src="/static/images/icon-check-white.svg"
                alt="icone-salvar"
              >
              {{ isEdit ? "Salvar alterações" : "Salvar" }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <page-scroll-top />
  </div>
</template>

<script>
import CardForm from '@/components/common/CardForm'
import profileService from '@/api/examProfile'
import Spinner from '@/components/common/Spinner'
import notify from '@/api/notification'
import SubHeader from '@/components/common/SubHeader'
import PageScrollTop from '@/components/common/PageScrollTop'
import ExamsNew from '@/components/Exams/ExamsNew'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ExamProfilesNew',
  components: {
    subheader: SubHeader,
    'page-scroll-top': PageScrollTop,
    'exams-new': ExamsNew,
    'card-form': CardForm,
    Spinner
  },
  data: () => ({
    branches: [],
    listBranches: [],
    name: '',
    author: '',
    laboratoryOwner: '',
    isEdit: false,
    loading: false,
    errorMessage: '',
    searchInput: ''
  }),
  methods: {
    ...mapActions(['setProfileExam']),
    ...mapActions(['examIsProfile']),
    ...mapActions(['clearExamList']),
    ...mapActions(['getExamDetails']),
    ...mapActions(['pushLoadingExam']),
    handleCreate () {
      let profile = this.profile
      let msgText = 'criado'
      const endpoint = this.isEdit ? 'editExamProfile' : 'createExamProfile'
      this.openModal()

      if (this.isEdit) {
        profile.id_profile = this.$route.params.id
        msgText = 'atualizado'
      }

      profileService[endpoint](profile)
        .then((response) => {
          if (response) {
            notify({
              message: 'Perfil de exames ' + msgText + ' com sucesso!'
            })
            this.closeModal()
            this.$router.push('/exam-profiles')
          }
        })
        .catch((err) => {
          if (err.response.data.code === 21) {
            this.errorMessage = err.response.data.message
            this.$refs.alreadyExistsModal.open()
          } else {
            notify({
              title: 'AVISO:',
              message: err.response.data.message
            })
          }
          this.closeModal()
        })
    },
    handleNew () {
      this.name = ''
      this.author = ''
      this.clearExamList()
      this.closeModal()
    },
    openModal () {
      this.$refs.transferModal.open()
    },
    closeModal () {
      this.$refs.transferModal.close()
    },
    closeAlreadyExistsModal () {
      this.$refs.alreadyExistsModal.close()
    },
    focusNextField (id) {
      document.getElementById(id).focus()
    },
    cleanItemsChecked () {
      this.listBranches = []
    }
  },
  computed: {
    ...mapGetters(['newExamsList']),
    ...mapGetters(['examIsLoading']),
    nameError () {
      return this.name.length > 0 && this.name.length < 3
    },
    authorError () {
      return this.author.length > 0 && this.author.length < 3
    },
    title () {
      if (this.isEdit) return 'Editar perfil de exames'
      return 'Novo perfil de exames'
    },
    isDisabled () {
      if (
        this.name.length > 2 &&
        this.author.length > 2 &&
        this.newExamsList.length > 0 &&
        !this.examIsLoading
      ) {
        return false
      }
      return true
    },
    profile () {
      const profileExams = this.newExamsList.map((exam) => {
        return {
          id_exam: exam.id,
          id_material: exam.sample.material,
          code_lis_exam: exam.details.code
        }
      })

      return {
        ...(this.isEdit && { id_profile: this.$route.params.id }),
        name: this.name,
        responsible_by: this.author,
        profile_exams: profileExams,
        laboratories: this.listBranches,
        id_laboratory_owner: this.laboratoryOwner
      }
    },
    ableToSeeIt () {
      return (this.branches.length)
    }
  },
  mounted () {
    /*profileService
      .getBranches()
      .then((res) => {
        this.branches = res.data
      })
      .catch((err) => {
        console.log(err)
      }) */

    this.examIsProfile(true)
    const id = this.$route.params.id
    // if route has id load profile to edit
    if (id) {
      this.isEdit = true
      this.loading = true
      profileService
        .getExamProfileById(id)
        .then((res) => {
          this.name = res.data.name
          this.author = res.data.responsible_by
          this.listBranches = res.data.laboratories
          this.laboratoryOwner = res.data.id_laboratory_owner
          let exams = res.data.profile_exams
          exams.forEach((exam) => {
            this.pushLoadingExam(exam.id_exam)
            this.setProfileExam({
              id: exam.id_exam,
              material: exam.id_material
            })
          })
          this.loading = false
        })
        .catch(() => {
          this.loading = false
          notify({
            title: 'AVISO:',
            message: 'Erro ao carregar perfil de exames para edição.'
          })
        })
    }
  },
  beforeDestroy () {
    this.clearExamList()
    this.examIsProfile(false)
    this.loading = false
    this.isEdit = false
  }
}
</script>

<style lang="scss">
@import "../../../static/stylesheets/mixins";

.exam-profiles-new {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  margin-top: 142px;

  &__title {
    font-size: 10px;
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-content: center;
    margin-bottom: 4px;
  }

  &__clean-btn {
    color: #7f1a54;
    font-size: 14px;
    cursor: pointer;
    letter-spacing: 0.32px;
    text-transform: none;
    font-weight: normal;
    text-decoration: underline;
    transition: all ease 0.1s;
    margin-bottom: 4px;

    &:hover {
      font-weight: 500;
    }
  }

  &__branches {
    display: flex;
    width: 100%;
    flex-wrap: wrap;

    p {
      font-size: 15px;
      line-height: 18px;
      letter-spacing: -0.3px;
      color: #7a7a7a;
    }
  }

  &__item {
    min-width: 100%;
    display: flex;
    margin-bottom: 10px;
    padding-right: 10px;

    &__label {
      font-size: 14px;
      color: #303030;
      text-transform: uppercase;
    }
  }

  &__spacer {
    border: none;
    height: 10px;
  }
  &__modal {
    text-align: center;

    &-loading {
      min-height: 90px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    h3 {
      font-family: Roboto;
      font-weight: 400;
      text-align: center;
      font-size: 20px;
      margin-top: 20px;
      letter-spacing: 0;
    }
  }
  &__modal-text {
    border-top: 1px solid #b8b7bf;
    padding-top: 20px;
    max-width: 270px;
    margin: 20px auto 0;
  }

  &__search-exams {
    margin-bottom: 130px;
  }

  &__text {
    margin-bottom: 10px;
    font-weight: normal;
    font-size: 22px;
    color: #7a7a7a;
  }

  &__loading {
    min-height: 65vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__container {
    width: 100%;
  }

  &__form {
    margin-bottom: 35px;
    p {
      font-size: 15px;
      letter-spacing: -0.3px;
      color: #303030;
      margin-bottom: 15px;
    }
    .card-form {
      &__container {
        border-radius: 6px;
        padding: 16px 20px;

        @media screen and (-ms-high-contrast: active),
          screen and (-ms-high-contrast: none) {
          .form-container {
            .md-flex-50 {
              min-width: 40%;
              max-width: calc(50% - 24px);
              margin: 0 auto;
            }
          }
        }
      }
    }
    .md-input-container {
      margin-bottom: 0 !important;
    }
  }

  &__fixed-footer {
    position: fixed;
    padding: 0 12em;
    width: calc(100% - 50px);
    min-width: 900px;
    margin-left: 50px;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ebebeb;
    box-shadow: 0px -5px 10px 0px rgba(0, 0, 0, 0.1);
  }
  &__footer {
    margin-top: 25px;
    margin-bottom: 25px;
    display: flex;
    justify-content: space-between;
    padding: 0 10px;

    .btn-bordered {
      padding: 5px 28px;
      text-transform: uppercase;
      background: none;
      border: 2px solid #7f1a54;
      border-radius: 3px;
      font-size: 12px;
      font-weight: 500;
      letter-spacing: 0.8px;
      color: #7f1a54;
      height: 38px;
    }
    .btn-primary {
      text-transform: uppercase;
      padding: 5px 37px;
      border-radius: 3px;
      font-size: 12px;
      font-weight: 500;
      letter-spacing: 0.8px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        margin-right: 5px;
      }
    }
  }

  .styled-checkbox {
    margin-right: 16px;

    input[type="checkbox"]:checked + label {
      background-color: #7f1a54;
      border: none !important;

      &:after {
        top: 3px;
        left: 2px;
      }
    }

    input[type="checkbox"]:focus + label {
      border: 1px solid #d1d1d1;
    }
  }

  @media screen and (-ms-high-contrast: active),
    screen and (-ms-high-contrast: none) {
    #txtNewSearchExam {
      min-height: 40px;
    }

    #highlight-title {
      justify-content: flex-start;
    }
  }
}

.modal-alredy-exists {
  .md-dialog {
    min-width: 630px;
  }

  .md-dialog-title {
    padding: 42px 80px 20px;
  }

  .md-dialog-content {
    padding: 0 80px 32px;
  }

  .standard-modal__title {
    align-items: center;

    &:before {
      content: "";
      width: 17px;
      height: 17px;
      background-image: url("/static/images/icon-alert-modal.svg");
      margin-right: 9px;
    }
  }
  .modal-container {
    text-align: center;

    .content {
      text-align: left;
      color: #4a4a4a;
      font-size: 14px;
      padding: 13px 12px 12px;
      background-color: #fdedd3;
      margin: 0 auto;
      display: flex;
      border-radius: 5px;
      width: 100%;

      .img-wrapper {
        width: 32px;
      }

      .message {
        width: 100%;
      }

      span {
        letter-spacing: 0;
        color: #4a4a4a;
        font-size: 14px;
        width: calc(100% - 32px);
      }

      ul {
        padding-left: 25px;
        margin: 6px 0;

        li {
          list-style: disc;
          font-weight: 500;
        }
      }
    }
    .highlight {
      background-color: #7f1a54;
      height: auto;
      padding: 12px 60px;
      font-size: 12px;
      letter-spacing: 1px;
      border-radius: 3px;
      margin: 20px auto 5px;
    }
  }
}
</style>
